'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addConfigToSideEffectDescritor = exports.makeSideEffectDescriptor = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _lodash = require('lodash.get');

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = require('lodash.pick');

var _lodash4 = _interopRequireDefault(_lodash3);

var _utils = require('./utils');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

var makeSideEffectDescriptor = exports.makeSideEffectDescriptor = function makeSideEffectDescriptor() {
  return {
    apiExtraParams: [],
    successEffect: [],
    failureEffect: [],
    unloadBy: [],
    mapSuccessAction: function mapSuccessAction(a) {
      return a;
    },
    mapFailureAction: function mapFailureAction(a) {
      return a;
    },
    mapLoadingAction: function mapLoadingAction(a) {
      return a;
    }
  };
};

var addConfigToSideEffectDescritor = exports.addConfigToSideEffectDescritor = function addConfigToSideEffectDescritor(sideEffect, config) {
  return _extends({}, sideEffect, (0, _lodash4.default)(config, 'callApi', 'takeEffect', 'takeEffectArgs', 'needEffect'), {
    apiExtraParams: [].concat(_toConsumableArray(sideEffect.apiExtraParams), _toConsumableArray((0, _utils.arrayze)((0, _lodash2.default)(config, 'apiExtraParams', [])))),
    successEffect: [].concat(_toConsumableArray(sideEffect.successEffect), _toConsumableArray((0, _utils.arrayze)((0, _lodash2.default)(config, 'successEffect', [])))),
    failureEffect: [].concat(_toConsumableArray(sideEffect.failureEffect), _toConsumableArray((0, _utils.arrayze)((0, _lodash2.default)(config, 'failureEffect', [])))),
    unloadBy: [].concat(_toConsumableArray(sideEffect.unloadBy), _toConsumableArray((0, _utils.arrayze)((0, _lodash2.default)(config, 'unloadBy', [])))),
    mapLoadingAction: typeof config.mapLoadingAction === 'function' ? function (a) {
      return config.mapLoadingAction(sideEffect.mapLoadingAction(a));
    } : sideEffect.mapLoadingAction,
    mapSuccessAction: typeof config.mapSuccessAction === 'function' ? function (a) {
      return config.mapSuccessAction(sideEffect.mapSuccessAction(a));
    } : sideEffect.mapSuccessAction,
    mapFailureAction: typeof config.mapFailureAction === 'function' ? function (a) {
      return config.mapFailureAction(sideEffect.mapFailureAction(a));
    } : sideEffect.mapFailureAction
  });
};